import { Link, useLocation, useNavigate } from "react-router-dom";
import { HbrShareIcon } from "./Mycustomsvgicons";
import { insertAudioBookAnalytics } from "./GeneralClasses";
import { ConstVariables } from "../newComponents2/ConstantVariables";

const AudioBookListContent = ({audiobookID, audiobookTitle, audioBookImage, stream, rate, downloads, shares}) => {
    const navigate = useNavigate();
    const location = useLocation();
    

    const shareAudioBook=async()=>{
        if(navigator.share){
            try{
                insertAudioBookAnalytics(audiobookTitle, ConstVariables.SHARES, 0);
                await navigator.share({
                    title: `${audiobookTitle}`,
                    text: `Listen to this audio book and your life will never be the same. Very inspiring and crucial for our eternal life.`,
                    url: `https://horemowbookreaderlite.web.app/hrmwaudiobook/${audiobookTitle}/${audiobookID}`,
                });
            }catch{
            }
        }else{
        }
    };

    const handleStreamAudio=()=>{
        insertAudioBookAnalytics(audiobookTitle, ConstVariables.STREAM, 0);
        navigate(`/hrmwaudiobook/${audiobookTitle}/${audiobookID}`, {state: {from: location.pathname}});
    };



    return ( 
        <div className="audiobookcontainer flex-column2" key={audiobookID}>
        <h3>{audiobookTitle}</h3>

        <div className="audiobookanalyticsview">
            <div className="flex-row2">
                <h4>stream:</h4>
                <p style={{color:"orangered", fontWeight:"bold"}}>{stream}</p>
            </div>

            <div className="flex-row2">
                <h4>rate:</h4>
                <p style={{color:"orangered", fontWeight:"bold"}}>{rate}</p>
            </div>

            <div className="flex-row2">
                <h4>downloads:</h4>
                <p style={{color:"orangered", fontWeight:"bold"}}>{downloads}</p>
            </div>

            <div className="flex-row2">
                <h4>shares:</h4>
                <p style={{color:"orangered", fontWeight:"bold"}}>{shares}</p>
            </div>
        </div>

        <img src={audioBookImage} alt="book cover"/>

        <div className="audiobookcontainerbottom flex-spacearound" style={{width:"100%"}}>
            <Link to={``}>
                
            </Link>
            <button onClick={()=>handleStreamAudio()}>
                 Listen
            </button>

            <HbrShareIcon width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>shareAudioBook()}/>
        </div>
      
      </div>
     );
}
export default AudioBookListContent;